import type {
    AriaDatapointType,
    EcsConfigStateSnapshot,
    PendingLogDatapointOutcome,
} from 'owa-analytics-types';
import {
    createLogDatapointObservation,
    getLogDatapointObserver,
} from 'owa-analytics-utils/lib/logDatapointObservation';
import { lazyLogDatapoint } from '../lazyFunctions';
import { prepareDatapointForLogging } from './logDatapoint';
import { trace } from 'owa-trace';

export function logConfigStateDatapoint(
    datapoint: AriaDatapointType,
    mapping: EcsConfigStateSnapshot,
    now: () => number
): PendingLogDatapointOutcome {
    const pending = createLogDatapointObservation(mapping, datapoint.getCreationTime(), now);
    try {
        prepareDatapointForLogging(datapoint);
        void lazyLogDatapoint
            .importAndExecute(datapoint, 'client_ecs_config_state', pending.observation)
            .catch(() => {
                trace.warn('Config-state lazy logging failed.', 'analytics');
                getLogDatapointObserver(pending.observation)?.settle('failed');
            });
    } catch {
        trace.warn('Config-state logging preparation failed.', 'analytics');
        getLogDatapointObserver(pending.observation)?.settle('failed');
    }
    return pending;
}
